import {
  MainPhotoSection,
  WebTerminalSection,
  IncreaseSection,
} from "../MainPage/MainPageStyles";
import {
  TermsCardsSection,
  DemandedSection,
  PopularAssetsSection,
} from "../TermsPage/TermsPageStyles";
import FirstCardIcon from "../../images/CardsImages/TermsCardIcons/developmentIcon.svg";
import SecondCardIcon from "../../images/CardsImages/TermsCardIcons/speedIcon.svg";
import ThirdCardIcon from "../../images/CardsImages/TermsCardIcons/security.svg";
import FourthCardIcon from "../../images/CardsImages/TermsCardIcons/levelIcon.svg";
import WebTerminal from "../../images/webTerminalPhoto.png";
import LaptopPhoto from "../../images/laptop__photo.png";
import TermsMainPhoto from "../../images/CHINAN.png";
import { NavLink } from "react-router-dom";
import { MTermsCard } from "../../components/Cards/TermsCard/TermsCard";
import {
  MRNA,
  MCD,
  TRIP,
  TSLA,
  NFLX,
  AAPL,
  POPULAR__ASSETS,
} from "../../widgets/Widgets";
import { motion } from "framer-motion";
import {
  animationFromTheSide,
  arrAnimation,
  arrAnimationFromTheSide,
} from "../../animations/animations";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../store/hooks";
import { generateLink } from "../../functions/routingFuntion";

export const TermsPage = () => {
  const language = useAppSelector((state) => state.locale.localStorageValue);
  const { t } = useTranslation();

  return (
    <main>
      <MainPhotoSection style={{ background: "#074275" }}>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.6, once: true }}
          className="container__standart flex__between"
          style={{ marginBottom: "0px" }}
        >
          <motion.div custom={1} variants={arrAnimation}>
            <h1>{t("termsPage.title1")}</h1>
            <p className="big__text">{t("termsPage.title2")}</p>
          </motion.div>
          <motion.div custom={2} variants={arrAnimation}>
            <img src={TermsMainPhoto} alt="#" />
          </motion.div>
        </motion.div>
      </MainPhotoSection>
      <TermsCardsSection>
        <div className="container__standart">
          <motion.h2
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.6, once: true }}
            variants={animationFromTheSide}
          >
            {t("termsPage.blockInfo1Tit")}
          </motion.h2>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.6, once: true }}
            className="flex__between terms-cards__container"
          >
            <MTermsCard
              img={FirstCardIcon}
              title={`${t("termsPage.blockInfo11")}`}
              custom={1}
              variants={arrAnimation}
              key={"termsCard1"}
            />
            <MTermsCard
              img={SecondCardIcon}
              title={`${t("termsPage.blockInfo12")}`}
              custom={2}
              variants={arrAnimation}
              key={"termsCard2"}
            />
            <MTermsCard
              img={ThirdCardIcon}
              title={`${t("termsPage.blockInfo13")}`}
              custom={3}
              variants={arrAnimation}
              key={"termsCard3"}
            />
            <MTermsCard
              img={FourthCardIcon}
              title={`${t("termsPage.blockInfo14")}`}
              custom={4}
              variants={arrAnimation}
              key={"termsCard4"}
            />
          </motion.div>
        </div>
      </TermsCardsSection>
      <WebTerminalSection>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.6, once: true }}
          className="container__standart flex__between"
        >
          <motion.div
            custom={1}
            variants={arrAnimation}
            className="web-terminal__info"
          >
            <h2>{t("termsPage.blockInfo2Tit")}</h2>
            <p className="big__text">{t("termsPage.blockInfo21")}</p>
            <p className="big__text">{t("termsPage.blockInfo22")}</p>
            <NavLink
              className="white__button flex__center"
              to={generateLink("/auth/login", language)}
            >
              {t("termsPage.blockInfo23")}
            </NavLink>
          </motion.div>
          <motion.div
            custom={2}
            variants={arrAnimation}
            className="web-terminal__photo"
          >
            <div>
              <img src={WebTerminal} alt="WebTerminal" />
            </div>
          </motion.div>
        </motion.div>
      </WebTerminalSection>
      <DemandedSection>
        <div className="container__standart">
          <motion.h2
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.6, once: true }}
            variants={animationFromTheSide}
          >
            {t("termsPage.blockInfo3Tit")}
          </motion.h2>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.6, once: true }}
            className="demanded-cards__container flex__between"
          >
            <motion.div custom={1} key={"frameMRNA"} variants={arrAnimation}>
              <iframe src={MRNA} title="MRNA" />
            </motion.div>
            <motion.div custom={2} key={"frameMCD"} variants={arrAnimation}>
              <iframe src={MCD} title="MCD" />
            </motion.div>
            <motion.div custom={3} key={"frameTRIP"} variants={arrAnimation}>
              <iframe src={TRIP} title="TRIP" />
            </motion.div>
            <motion.div custom={4} key={"frameTSLA"} variants={arrAnimation}>
              <iframe src={TSLA} title="TSLA" />
            </motion.div>
            <motion.div custom={5} key={"frameNFLX"} variants={arrAnimation}>
              <iframe src={NFLX} title="NFLX" />
            </motion.div>
            <motion.div custom={6} key={"frameAAPL"} variants={arrAnimation}>
              <iframe src={AAPL} title="AAPL" />
            </motion.div>
          </motion.div>
        </div>
      </DemandedSection>
      <IncreaseSection>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.6, once: true }}
          className="flex__between container__standart"
        >
          <motion.div
            custom={1}
            variants={arrAnimation}
            className="web-terminal__info"
          >
            <h2>{t("termsPage.blockInfo4Tit")}</h2>
            <p className="big__text">{t("termsPage.blockInfo41")}</p>
            <NavLink
              className="white__button flex__center"
              to={generateLink("/auth/login", language)}
            >
              {t("termsPage.blockInfo42")}
            </NavLink>
          </motion.div>
          <motion.div
            custom={2}
            variants={arrAnimation}
            className="web-terminal__photo"
          >
            <img src={LaptopPhoto} alt="" />
          </motion.div>
        </motion.div>
      </IncreaseSection>
      <PopularAssetsSection>
        <div className="container__standart">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.6, once: true }}
            className="top"
          >
            <motion.h2 custom={1} variants={arrAnimationFromTheSide}>
              {t("termsPage.blockInfo5Tit")}
            </motion.h2>
            <motion.p
              custom={2}
              variants={arrAnimationFromTheSide}
              className="big__text"
            >
              {t("termsPage.blockInfo51")}
            </motion.p>
          </motion.div>
          <div className="widget">
            <iframe src={POPULAR__ASSETS} title="POPULAR ASSETS"></iframe>
          </div>
        </div>
      </PopularAssetsSection>
    </main>
  );
};
